import { render, staticRenderFns } from "./reviewDialog.vue?vue&type=template&id=f9206f38&scoped=true&"
import script from "./reviewDialog.vue?vue&type=script&lang=js&"
export * from "./reviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./reviewDialog.vue?vue&type=style&index=0&id=f9206f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9206f38",
  null
  
)

export default component.exports